import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import CsvImportWizard, { CsvImportWizardProps } from "./CsvImportWizard";

type CsvImportModalProps = CsvImportWizardProps & {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  subtitle: string;
  icon: string;
};

const CsvImportModal: React.FC<CsvImportModalProps> = ({
  isOpen,
  toggle,
  title,
  subtitle,
  icon,
  ...wizardProps
}) => (
  <Modal
    size="xl"
    isOpen={isOpen}
    toggle={toggle}
    centered
    className="data-import-modal"
  >
    <ModalHeader className="p-3 border-bottom" toggle={toggle}>
      <div className="d-flex align-items-center gap-3">
        <div
          className="rounded-2 d-flex align-items-center justify-content-center bg-secondary-subtle flex-shrink-0"
          style={{ width: 42, height: 42 }}
        >
          <i className={`${icon} text-secondary`} style={{ fontSize: 22 }} />
        </div>
        <div>
          <div className="fw-semibold" style={{ fontSize: 16, lineHeight: 1.3 }}>
            {title}
          </div>
          <div className="text-muted fw-normal mt-1" style={{ fontSize: 14 }}>
            {subtitle}
          </div>
        </div>
      </div>
    </ModalHeader>
    <ModalBody className="p-4">
      {isOpen && <CsvImportWizard {...wizardProps} />}
    </ModalBody>
  </Modal>
);

export default CsvImportModal;
